import { render, staticRenderFns } from "./mstrbudget.vue?vue&type=template&id=2359286d"
import script from "./mstrbudget.vue?vue&type=script&lang=js"
export * from "./mstrbudget.vue?vue&type=script&lang=js"
import style0 from "./mstrbudget.vue?vue&type=style&index=0&id=2359286d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports